import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import WorkflowBox from "../WorkFlowCardView/WorkflowBox";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import WorkflowWrap from "../style";
import { Checkbox } from "antd";
import { object } from "yup";

const WorkflowView = ({
  setOpenView,
  openView,
  viewData,
  setViewData,
  setEditNode,
  EditNodeData,
  setEditData,
  handleCardUpdate,
  handleCardChange,
  updateData,
  editNode,
  allWorkFlow,
  editPermission,
  ischecked,
  setIschecked,
}) => {
  // const [checked, setChecked] = useState(
  //   viewData?.value?.defaultdeadline || null,
  // );
  const key = viewData.key;
  let length = viewData.value.workFlow.length;
  console.log(viewData, "viewDeeeeata");

  const addWorkflowBox = (length) => {
    let newfield = { [length]: "" };
    let temp = [...viewData.value.workFlow, newfield];

    viewData.value.workFlow = temp;

    setEditNode({
      editable: true,
      index: length,
      key: key,
      value: viewData,
      newNode: true,
    });
    EditNodeData(viewData.value.workFlow);
    setEditData(viewData.value);
  };

  const handlechecked = (index) => {
    console.log(index, "nnnnnnnn");
    setIschecked(index);
  };

  useEffect(() => {
    handleCardUpdate();
  }, [ischecked]);

  return (
    <>
      <Modal
        show={openView}
        onHide={() => {
          setOpenView(false);
          setEditNode({
            editable: false,
            index: "",
            key: "",
            value: "",
          });
        }}
        centered
        style={{ backgroundColor: "rgb(95, 93, 93, 0.75)" }}
        size="sm"
      >
        <WorkflowWrap>
          <div className="pe-2">
            <CloseIcon
              className="float-end  mt-2"
              onClick={() => {
                setOpenView(false);
                setViewData("");
                setEditNode({
                  editable: false,
                  index: "",
                  key: "",
                  value: "",
                });
              }}
              style={{ cursor: "pointer", color: "#4eb6ee" }}
            />
            <div className="modal-view-data">
              <span className="workflow-name">
                <strong className="me-2">Workflow ID:</strong>
                <span
                  style={{
                    color: "#4eb6ee",
                  }}
                >
                  {viewData.value.workFlowId}
                </span>
              </span>
              <span className="workflow-name workflowname">
                <strong className="me-2">Workflow name:</strong>
                {viewData.value.workFlowName}
              </span>
              <span className="workflow-name workflowname">
                <strong className="me-2">Project name:</strong>
                {viewData.value.project_name}
              </span>
            </div>
            <div className="flow-modal-view">
              <div>
                Deadline Based :{" "}
                {viewData?.value?.workFlow[ischecked]?.[ischecked]
                  ? viewData?.value?.workFlow[ischecked]?.[ischecked]
                  : null}
              </div>
              {viewData.value.workFlow.map((e, index) => {
                const workFlowLength = index + 1;
                let viewdata = [];
                Object.keys(e).map((n) => {
                  viewdata.push(e[n]);
                });

                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                      className="conatainer_one"
                    >
                      <div>
                        {workFlowLength <= 15 && (
                          <WorkflowBox
                            index={index}
                            editNode={editNode}
                            updateData={updateData}
                            id={key}
                            allWorkFlow={allWorkFlow}
                            viewData={viewdata}
                            value={viewData}
                            setViewData={setViewData}
                            handleCardChange={handleCardChange}
                            setEditNode={setEditNode}
                            EditNodeData={EditNodeData}
                            handleCardUpdate={handleCardUpdate}
                            setEditData={setEditData}
                            openView={openView}
                            verticalview={true}
                            editPermission={editPermission}
                            ischecked={ischecked}
                            setIschecked={setIschecked}
                          />
                        )}
                      </div>
                      <div>
                        {console.log(ischecked, "indexindex", index)}
                        <Checkbox
                          checked={ischecked === index ? true : false}
                          onChange={() => {
                            setEditData(viewData.value);
                            handlechecked(index);
                          }}
                        />
                      </div>
                    </div>
                  </>
                );
              })}
              {editNode &&
              editNode.editable &&
              editNode.key === key &&
              editNode.newNode
                ? null
                : length <= 15 && (
                    <div
                      className="verticalviewplus"
                      style={{ cursor: "pointer", color: "#4eb6ee" }}
                      onClick={() => {
                        addWorkflowBox(length, key);
                      }}
                    >
                      <LocalHospitalIcon />
                    </div>
                  )}
            </div>
          </div>
        </WorkflowWrap>
      </Modal>
    </>
  );
};

export default WorkflowView;
